import { ProjectQueryFragment } from '@sc/graphql';

const clamp01 = (n: number) => Math.min(1, Math.max(0, n));

export const useChatUsage = ({
  query,
  brandColour,
}: {
  query: ProjectQueryFragment | undefined;
  brandColour?: string | undefined;
}) => {
  const rateLimit = query?.rateLimit;

  const queryMultiplier = rateLimit?.queryMultiplier ?? 0;

  const queriesConsumed = rateLimit?.queriesConsumed ?? 0;

  const usageFraction =
    queryMultiplier > 0 ? queriesConsumed / queryMultiplier : 0;

  const showUsageMarker = !!query && queryMultiplier > 0;

  const usagePercent = Math.round(clamp01(usageFraction) * 100);

  const usageMarkerColour =
    usageFraction >= 0.9 ? '#e74a4a' : brandColour ?? '#55C78E';

  const queriesRemaining = rateLimit?.queriesRemaining ?? null;

  const resetMinutes = rateLimit?.resetsAt
    ? Math.max(
        1,
        Math.ceil((new Date(rateLimit.resetsAt).getTime() - Date.now()) / 60_000)
      )
    : null;

  const queriesTooltip = rateLimit
    ? `${rateLimit.queriesUsedThisHour} of ${
        rateLimit.queriesPerUserPerHour
      } queries used this hour${
        resetMinutes && rateLimit.queriesUsedThisHour > 0
          ? ` · resets in ${resetMinutes} min`
          : ''
      }`
    : '';

  return {
    rateLimit,
    showUsageMarker,
    usageFraction,
    usagePercent,
    queriesConsumed,
    queryMultiplier,
    usageMarkerColour,
    queriesRemaining,
    resetMinutes,
    queriesTooltip,
  };
};
